import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Navbar from "./components/Navbar";
import Login from "./pages/Login";
import Home from "./pages/Home";
import Vehicule from "./pages/Vehicule";
import Ajoutervoiture from "./pages/AjouterVoiture";
import UsagersPage from "./pages/UsagersPage";
import VehiculesPage from "./pages/VehiculesPage";
import QRCodeGenerator from "./pages/Qrcd";
import MenuUsage from "./pages/menuUsage";
import UserPage from "./pages/UserPage";
import AvisPage from "./pages/Avispage";
import CheckPage from "./pages/CheckPage";
import MenuVehicule from "./pages/menuVehicule";
import Menucheckpoint from "./pages/menuCheckpoint";
import HistoriqueControleur from "./components/historiqueControleur";
import Statistiques from "./pages/Statistique";
import QRCDOffline from "./pages/QrcdOffline";
import AjoutVoiture from "./pages/AjouterVoiture";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Fonction pour ne garder que certaines clés dans le localStorage
function clearLocalStorageExcept(keysToKeep = []) {
  const toKeep = {};
  keysToKeep.forEach(key => {
    if (localStorage.getItem(key) !== null) {
      toKeep[key] = localStorage.getItem(key);
    }
  });
  localStorage.clear();
  Object.entries(toKeep).forEach(([k, v]) => localStorage.setItem(k, v));
}

// Hook d'auto-déconnexion
function useAutoLogout() {
  const navigate = useNavigate();
  const statu = localStorage.getItem("statu");
  // 10h pour enregistreur, sinon 5 minutes
  const timeout = statu === "enregistreur" ? 10 * 60 * 60 * 1000 : 5 * 60 * 1000;

  useEffect(() => {
    let timer;
    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        clearLocalStorageExcept(["numero_serie"]);
        navigate("/");
      }, timeout);
    };
    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];
    events.forEach(event => window.addEventListener(event, resetTimer));
    resetTimer();
    return () => {
      clearTimeout(timer);
      events.forEach(event => window.removeEventListener(event, resetTimer));
    };
  }, [navigate, timeout]);
}

const Layout = () => {
  useAutoLogout(); // ← Ajoute ce hook ici

  const location = useLocation();
  return (
    <>
      <div className="w-[90%] z-50 h-[20%] flex flex-col items-center text-white absolute ml-[5%] p-3">
        <Navbar />
      </div>
      <div className="w-[90%]  mt-32 h-[80%] absolute ml-[5%] p-9">
        <Routes>
          <Route path="/" element={<Login />} />

          <Route path="/home" element={<Home />} />
          {localStorage.getItem("statu") === "transport" && (
              <>
              <Route path="/avispage" element={<AvisPage />} />
                 <Route path="/statistiques" element={<Statistiques />} />

                   <Route path="/menucheckpoint" element={<Menucheckpoint />} />

                <Route
                  path="/ajoutvoiture/qrcd/:id"
                  element={<QRCodeGenerator />}
                />
                <Route
                  path="/ajoutvoiture/qrcdoffline"
                  element={<QRCDOffline />}
                />
                <Route path="/ajoutvoiture" element={<AjoutVoiture />} />
              </>
            )}
          {localStorage.getItem("statu") === "admin" && (
              <>
                <Route path="/vehiculepageajout" element={<VehiculesPage />} />
                <Route
                  path="/vehiculepageajout/qrcd/:id"
                  element={<QRCodeGenerator />}
                />
                <Route
                  path="/ajoutvoiture/qrcd/:id"
                  element={<QRCodeGenerator />}
                />
                <Route
                  path="/ajoutvoiture/qrcdoffline"
                  element={<QRCDOffline />}
                />
                <Route path="/ajoutvoiture" element={<AjoutVoiture />} />
              </>
            )}
          {localStorage.getItem("statu") === "enregistreur" && (
              <>
                <Route path="/vehiculepageajout" element={<VehiculesPage />} />
                <Route
                  path="/vehiculepageajout/qrcd/:id"
                  element={<QRCodeGenerator />}
                />
                <Route
                  path="/ajoutvoiture/qrcd/:id"
                  element={<QRCodeGenerator />}
                />
                <Route
                  path="/ajoutvoiture/qrcdoffline"
                  element={<QRCDOffline />}
                />
                <Route path="/ajoutvoiture" element={<AjoutVoiture />} />
              </>
            )}



          {localStorage.getItem("statu") === "admin_police"&&
            (
              <>
                <Route path="/menucheckpoint" element={<Menucheckpoint />} />
                <Route path="/users" element={<UserPage />} />
                <Route path="/statistiques" element={<Statistiques />} />
              </>
            )}
          {
            localStorage.getItem("statu") === "admin_gendarmerie"&&
            (
              <>
                <Route path="/menucheckpoint" element={<Menucheckpoint />} />
                <Route path="/statistiques" element={<Statistiques />} />
                <Route path="/users" element={<UserPage />} />
              </>
            )}
          {localStorage.getItem("statu") === "admin" && (
            <Route path="/statistiques" element={<Statistiques />} />
          )}
          {/* <Route path="/menuvehicule" element={<MenuVehicule />} /> */}
          <Route path="/check" element={<CheckPage />} />
          <Route path="/vehicule/ajout" element={<Ajoutervoiture />} />

          <Route path="/menuvehicule" element={<MenuVehicule />} />
          {localStorage.getItem("statu") === "admin" && (
            <>
                <Route path="/menucheckpoint" element={<Menucheckpoint />} />

              <Route path="/vehiculepageajout" element={<VehiculesPage />} />
              <Route
                path="/vehiculepageajout/qrcd/:id"
                element={<QRCodeGenerator />}
              />
              <Route
                path="/ajoutvoiture/qrcd/:id"
                element={<QRCodeGenerator />}
              />
              <Route
                path="/ajoutvoiture/qrcdoffline"
                element={<QRCDOffline />}
              />
              <Route path="/ajoutvoiture" element={<AjoutVoiture />} />

              <Route path="/users" element={<UserPage />} />
            </>
          )}

          <Route path="/usagers" element={<UsagersPage />} />
          <Route path="/menuusage" element={<MenuUsage />} />

          <Route path="/vehiculepage" element={<VehiculesPage />} />
          <Route path="/vehiculepageajout" element={<VehiculesPage />} />
          <Route path="/avispage" element={<AvisPage />} />
          <Route
            path="/historique-controleur"
            element={<HistoriqueControleur />}
          />
          <Route path="/vehiculepage/qrcd/:id" element={<QRCodeGenerator />} />
        </Routes>
      </div>
    </>
  );
};

const App = () => {
  return (
    <Router>
      <Layout />
    </Router>
  );
};

export default App;
